module.exports = __webpack_public_path__ + "static/media/iconSurveysActive.2fdc0569.svg";